import OfferPresenter from "presenters/OfferPresenter";

export const initialValues = {
  firstName: "",
  lastName: "",
  postalCode: "",
  country: "US",
};

export const attributesToSubmit = (subscription) => {
  const {
    offer,
    paymentProvider,
    payment: { firstName, lastName, postalCode, recurlyToken },
  } = subscription;

  return {
    data: {
      type: "subscriptions",
      attributes: {
        payment: {
          firstName,
          lastName,
          postalCode,
          recurlyToken,
          templateSlug: "",
        },
      },
      relationships: {
        "payment-provider": {
          data: {
            attributes: {
              name: paymentProvider.name,
            },
            type: "payment-providers",
          },
        },
        offer: {
          data: {
            id: OfferPresenter.id(offer),
            attributes: {
              name: OfferPresenter.name(offer),
              "display-name": OfferPresenter.displayName(offer),
              description: OfferPresenter.description(offer),
              price: OfferPresenter.price(offer),
              duration: OfferPresenter.duration(offer),
              "duration-unit": OfferPresenter.durationUnit(offer),
              image: OfferPresenter.image(offer),
              status: OfferPresenter.status(offer),
            },
            type: "offers",
          },
        },
      },
    },
  };
};
